export var dropdownSearchInputStyles = {
  root: function root(_ref) {
    var v = _ref.variables;
    return {
      flexBasis: v.comboboxFlexBasis,
      flexGrow: 1
    };
  },
  input: function input(_ref2) {
    var p = _ref2.props;
    return Object.assign({
      width: '100%',
      backgroundColor: 'transparent',
      borderWidth: 0
    }, p.inline && {
      padding: 0,
      lineHeight: 'initial'
    });
  }
};